import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const OuterWrapper = styled.section`
  color: ${({ theme, textColor }) => theme.themeColors[textColor]};
  font-size: ${({ theme }) => theme.fontSize(2)};
  text-align: ${({ textAlignment }) => textAlignment};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme, textColor }) => theme.themeColors[textColor]};
  }

  h2 {
    font-size: ${({ textAlignment }) =>
      (textAlignment === "center" && "2.375rem") || "1.5rem"};
    letter-spacing: -0.066875rem;
    line-height: 1.13125;
    margin: 0;
    padding-bottom: 1rem;
    text-align: ${({ textAlignment }) => textAlignment};

    ${({ theme }) => theme.mq.xl`
      font-size: ${({ textAlignment }) =>
        (textAlignment === "center" && "3rem") || "2rem"};
      line-height: 1.2;
      max-width: ${({ textAlignment }) =>
        (textAlignment === "center" && "100%") || "90%"};
    `};
  }

  h3 {
    letter-spacing: 0;
    font-size: 1.125rem;

    ${({ theme }) => theme.mq.xl`
      font-size: 1.5rem;
      line-height: 1.22;
      letter-spacing: -0.0025rem;
    `};
  }

  p,
  div {
    color: ${({ theme, backgroundColor }) =>
      (backgroundColor === "orange" && "white") ||
      theme.themeColors.darkGreen4};
  }

  p:empty {
    display: none;
  }

  ul {
    margin: 0 0 2rem;
    padding: 0 0 0 0.75rem;

    :last-of-type,
    li:last-of-type,
    li:last-of-type p {
      margin: 0;
    }

    li {
      color: ${({ theme, backgroundColor }) =>
        (backgroundColor === "orange" && "white") ||
        theme.themeColors.darkGreen4};
      line-height: 1.3125;

      &::marker {
        color: ${({ theme, backgroundColor }) =>
          (backgroundColor === "orange" && "white") ||
          theme.themeColors.primary};
        height: 0.5rem;
        width: 0.5rem;
      }
    }
  }
`;

const renderOptions = {
  // convert line breaks "\n" to <br />
  renderText: (text) => {
    return text.split("\n").reduce((children, textSegment, index) => {
      return [
        ...children,
        index > 0 && <br key={`${textSegment}-${index + 1}`} />,
        textSegment,
      ];
    }, []);
  },
};

export default function RichTextField({
  backgroundColor,
  className,
  richText,
  textAlignment,
  textColor,
}) {
  return (
    <OuterWrapper
      backgroundColor={backgroundColor}
      textAlignment={textAlignment}
      className={className}
      textColor={textColor}
    >
      {documentToReactComponents(richText, renderOptions)}
    </OuterWrapper>
  );
}

RichTextField.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  richText: PropTypes.shape({}),
  textAlignment: PropTypes.string,
  textColor: PropTypes.string,
};

RichTextField.defaultProps = {
  backgroundColor: undefined,
  className: undefined,
  richText: undefined,
  textAlignment: "left",
  textColor: "darkGreen1",
};
